export default (that) => [
  {
    text: that.$l('menu_text_detail') || '查看详情',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: that.$l('menu_text_delete') || '删除需求',
    icon: 'el-icon-delete',
    menuType: 'delete',
    allow: 'D',
    disabled: ({ amzFlipOrderStatus }) =>
      amzFlipOrderStatus === 'S' ||
      amzFlipOrderStatus === 'P' ||
      amzFlipOrderStatus === 'D' ||
      amzFlipOrderStatus === 'T' ||
      amzFlipOrderStatus === 'A',
  },
  {
    text: that.$l('menu_text_edit_demand') || '编辑需求',
    icon: 'el-icon-edit',
    menuType: 'editDetail',
    allow: 'M',
    disabled: ({ amzFlipOrderStatus }) =>
      amzFlipOrderStatus === 'S' ||
      amzFlipOrderStatus === 'P' ||
      amzFlipOrderStatus === 'D' ||
      amzFlipOrderStatus === 'T' ||
      amzFlipOrderStatus === 'A',
  },
  {
    text: that.$l('menu_text_export') || '导出清单',
    icon: 'el-icon-download',
    menuType: 'export',
    allow: 'E',
    divided: true,
    data: { templateGroup: 'ecom-flipOrder' },
    disabled: ({ amzFlipOrderStatus }) => amzFlipOrderStatus === 'D',
  },
  // {
  //   text: that.$l('menu_text_review') || '提交审核',
  //   icon: 'el-icon-s-check',
  //   menuType: 'review',
  //   divided: true,
  //   allow: 'R',
  //   disabled: ({ amzFlipOrderStatus }) =>
  //     !(amzFlipOrderStatus === 'N' || amzFlipOrderStatus === 'B' || amzFlipOrderStatus === 'R'),
  // },
  // {
  //   text: that.$l('menu_text_purchase') || '提交采购',
  //   icon: 'el-icon-sell',
  //   menuType: 'purchase',
  //   divided: false,
  //   allow: 'S',
  //   disabled: ({ amzFlipOrderStatus }) =>
  //     amzFlipOrderStatus === 'S' ||
  //     amzFlipOrderStatus === 'P' ||
  //     amzFlipOrderStatus === 'D' ||
  //     amzFlipOrderStatus != 'A',
  // },
  // {
  //   text: that.$l('menu_text_purchase_rejection') || '取消采购',
  //   icon: 'el-icon-s-check',
  //   menuType: 'rejection',
  //   divided: false,
  //   allow: 'Z',
  //   disabled: ({ amzFlipOrderStatus }) =>
  //     !(amzFlipOrderStatus === 'S'),
  // },
]
